module.exports = __webpack_public_path__ + "static/img/punchCard.7726811.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/punchCard.png
// module id = puPV
// module chunks = 1